import { render, staticRenderFns } from "./WelcomeModule.vue?vue&type=template&id=66812857&scoped=true&"
import script from "./WelcomeModule.vue?vue&type=script&lang=js&"
export * from "./WelcomeModule.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeModule.vue?vue&type=style&index=0&id=66812857&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66812857",
  null
  
)

export default component.exports